import type { Activity } from '@/types'

export type ActivityStatus = 'live' | 'next' | 'upcoming' | 'past'

const DEFAULT_DURATION_MS = 2 * 60 * 60 * 1000

export function getActivityStatusMap(
  activities: Activity[],
  now: Date
): Record<string, ActivityStatus> {
  const nowMs = now.getTime()
  const sorted = [...activities].sort(
    (a, b) => new Date(a.start_time_utc).getTime() - new Date(b.start_time_utc).getTime()
  )

  const statuses: Record<string, ActivityStatus> = {}
  let nextAssigned = false

  for (const a of sorted) {
    const start = new Date(a.start_time_utc).getTime()
    const end = a.end_time_utc
      ? new Date(a.end_time_utc).getTime()
      : start + DEFAULT_DURATION_MS

    if (nowMs >= start && nowMs < end) {
      statuses[a.id] = 'live'
    } else if (nowMs >= end) {
      statuses[a.id] = 'past'
    } else if (!nextAssigned) {
      statuses[a.id] = 'next'
      nextAssigned = true
    } else {
      statuses[a.id] = 'upcoming'
    }
  }

  return statuses
}

export function formatTimeUntil(targetIso: string, now: Date): string {
  const diffMs = new Date(targetIso).getTime() - now.getTime()
  if (diffMs <= 0) return 'now'
  const totalMinutes = Math.floor(diffMs / 60_000)
  if (totalMinutes < 1) return 'now'
  if (totalMinutes < 60) return `in ${totalMinutes}m`
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours < 24) {
    return minutes > 0 ? `in ${hours}h ${minutes}m` : `in ${hours}h`
  }
  const days = Math.floor(hours / 24)
  return `in ${days}d`
}
